var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-voucher',{attrs:{"submit":_vm.submit,"delete":_vm.deleteItem,"role":"update"}})}
var staticRenderFns = []

export { render, staticRenderFns }